<template>
  <div class="select-wrapper">
    <h2>{{ $props.question }}</h2>
    <div class="options-outer-wrapper">
      <div class="options-inner-wrapper">
        <div
          class="selection grow"
          v-for="(el, i) in $props.selections"
          :key="i"
          @click="onSelect(el)"
          :class="{ 'selected-option': el.value === selectedValue }"
          :style="{
            'min-width': selectionMinWidth
          }"
        >
          <h3 class="selection-name">{{ el.name }}</h3>
          <font-awesome-icon
            v-if="el.value === selectedValue"
            class="icon icon-yes grow hide-on-mobile"
            :icon="['fas', 'check']"
          />
        </div>
      </div>
      <div>
        <div class="select-image-wrapper shadow">
          <img class="select-image" :src="image" :alt="$props.question" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SelectOneInput",
  props: {
    question: {
      type: String,
      required: true
    },
    image: {
      type: String,
      required: true
    },
    selections: {
      type: Array,
      required: true
    },
    selectedValue: {
      required: true
    },
    clickedCallback: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      screenWidth: window.innerWidth
    };
  },
  computed: {
    selectionMinWidth() {
      let maxLength = 0;
      this.$props.selections.forEach(s => {
        if (s.name.length > maxLength) maxLength = s.name.length;
      });
      const minWidth = maxLength * 10 + 30;
      if (minWidth >= this.screenWidth - 40) {
        return "90%";
      }
      return minWidth + "px";
    }
  },
  created() {
    window.addEventListener("resize", this.widthChanged);
  },
  destroyed() {
    window.removeEventListener("resize", this.widthChanged);
  },
  methods: {
    onSelect(selection) {
      this.$props.clickedCallback(selection.value);
    },
    widthChanged() {
      this.screenWidth = window.innerWidth;
    }
  }
};
</script>

<style scoped lang="scss">
@import "../common/_variables.scss";

.select-image-wrapper {
  border-radius: 10px;
  max-width: 450px;
}
.select-image {
  max-width: 450px;
  width: 100%;
  border-radius: 10px;
  display: block;
}
.selected-image {
  border: 4px solid $color-primary;
}

.options-outer-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  margin-top: 50px;
  /*background-color: #CCC;*/
}
.options-outer-wrapper > div {
  width: 100%;
}

.options-inner-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.selection {
  padding: 10px;
  text-align: left;
  border: 1px solid $color-primary;
  border-radius: 8px;
  background-color: #e5f3f4;
  margin: 10px;
  color: $color-primary;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.selection-name {
  margin: 0;
}

.selected-option {
  border-width: 3px;
}

@media only screen and (max-width: 768px) {
  .options-outer-wrapper {
    flex-direction: column;
    margin-top: 15px;
  }

  .options-inner-wrapper {
    margin-bottom: 20px;
    order: 0;
  }

  .select-image-wrapper {
    box-shadow: unset;
    width: 100%;
    max-width: 100%;
  }

  .select-image {
    width: 100%;
    max-width: 100%;
  }

}
</style>
